export const SERVICES = {
  nails: {
    slug: "stylizacja-paznokci-katowice",
    title: "Stylizacja Paznokci",
    subtitle: "Manicure hybrydowy, żelowy, tytanowy — Katowice Ligota",
    metaTitle:
      "Stylizacja Paznokci Katowice — Manicure Hybrydowy i Żelowy | BEAUTIX",
    metaDescription:
      "Profesjonalna stylizacja paznokci w Katowicach — manicure hybrydowy, paznokcie żelowe, manicure tytanowy oraz pedicure kosmetyczny. Studio BEAUTIX, ul. Ligocka 80.",
    hero: "Paznokcie, które zapamiętają koleżanki",
    intro:
      "W studiu BEAUTIX na katowickiej Ligocie tworzymy stylizacje, które łączą trwałość i klasę. Każdy zabieg wykonujemy z zachowaniem najwyższych standardów higieny i pełnym poszanowaniem naturalnej płytki paznokcia.",
    items: [
      {
        name: "Manicure hybrydowy",
        desc: "Najpopularniejsza forma zdobienia w Katowicach — trwałość 3-4 tygodnie, dziesiątki kolorów, opieka nad kondycją płytki. Wykonujemy dokładne opracowanie skórek e-frezarką.",
        keyword: "manicure hybrydowy Katowice",
      },
      {
        name: "Paznokcie żelowe",
        desc: "Metoda żelowa dla naturalnego, elastycznego wyglądu i długości szytej na miarę. Polecamy szczególnie przy słabych, łamliwych płytkach.",
        keyword: "paznokcie żelowe Katowice",
      },
      {
        name: "Manicure tytanowy",
        desc: "Nowoczesna metoda 2026 roku — cienkie, mocne i elastyczne przedłużenie z użyciem żelu tytanowego. Efekt lekkości i wytrzymałości.",
        keyword: "manicure tytanowy Katowice",
      },
      {
        name: "Pedicure kosmetyczny",
        desc: "Zadbane stopy, dokładne opracowanie płytki i skórek oraz malowanie hybrydą. Idealne dopełnienie manicure.",
        keyword: "pedicure Katowice",
      },
      {
        name: "Zdobienia autorskie",
        desc: "French, ombre, chrom, cat-eye, ręcznie malowane wzory. Twoje paznokcie — Twój styl.",
        keyword: "zdobienia paznokci Katowice",
      },
    ],
  },
  podology: {
    slug: "podologia-katowice",
    title: "Podologia",
    subtitle: "Gabinet podologiczny — leczenie stóp w Katowicach",
    metaTitle:
      "Podolog Katowice — Gabinet Podologiczny BEAUTIX",
    metaDescription:
      "Gabinet podologiczny BEAUTIX w Katowicach. Leczenie wrastających paznokci, usuwanie odcisków, pedicure leczniczy, brodawki, grzybica. ul. Ligocka 80.",
    hero: "Zdrowe stopy zaczynają się od dobrego podologa",
    intro:
      "Nasz gabinet podologiczny w Katowicach łączy medyczną dokładność z komfortem, jakiego oczekujesz od nowoczesnego studia. Rozwiązujemy dolegliwości stóp, dobierając zabieg do przyczyny — nie tylko do objawu.",
    items: [
      {
        name: "Leczenie wrastających paznokci",
        desc: "Diagnostyka i bezinwazyjna korekcja klamrami ortonyksyjnymi. Skuteczna pomoc przy wrastających paznokciach u dorosłych i dzieci.",
        keyword: "wrastający paznokieć Katowice",
      },
      {
        name: "Pedicure leczniczy",
        desc: "Profesjonalne opracowanie stóp z użyciem frezarki, redukcja modzeli, pielęgnacja bardzo suchej skóry i pękających pięt.",
        keyword: "pedicure leczniczy Katowice",
      },
      {
        name: "Usuwanie odcisków i modzeli",
        desc: "Bezbolesne usuwanie odcisków twardych i miękkich oraz nagniotków — z zaleceniami, jak zapobiegać nawrotom.",
        keyword: "usuwanie odcisków Katowice",
      },
      {
        name: "Brodawki wirusowe i grzybica",
        desc: "Terapia brodawek wirusowych stóp oraz wsparcie w leczeniu grzybicy paznokci — zgodnie z aktualną wiedzą podologiczną.",
        keyword: "leczenie brodawek Katowice",
      },
      {
        name: "Rekonstrukcja i tamponada",
        desc: "Rekonstrukcje płytki paznokcia po urazach oraz tamponady przy stanach zapalnych wału paznokciowego.",
        keyword: "rekonstrukcja paznokcia Katowice",
      },
    ],
  },
  face: {
    slug: "kosmetyka-twarzy-katowice",
    title: "Kosmetyka Twarzy",
    subtitle: "Nowoczesne zabiegi na twarz w Katowicach",
    metaTitle:
      "Kosmetyka Twarzy Katowice — Oczyszczanie, Mezoterapia, Kobido | BEAUTIX",
    metaDescription:
      "Zabiegi kosmetyczne twarzy w Katowicach: oczyszczanie wodorowe, mezoterapia mikroigłowa, masaż Kobido, stymulatory tkankowe. Studio BEAUTIX, ul. Ligocka 80.",
    hero: "Skóra, w której czujesz się jak u siebie",
    intro:
      "Zabiegi kosmetyki twarzy w BEAUTIX opierają się na filozofii skin longevity 2026 — regeneracji zamiast maskowania. To zupełnie nowy sposób myślenia o skórze, który wydłuża okres jej zdrowego funkcjonowania. Łączymy nowoczesną kosmetologię, biotechnologię i wiedzę medyczną z troską o ciało, umysł i emocje — pracujemy na kondycji bariery hydrolipidowej, mikrobiomie i głębokim ukojeniu skóry.",
    items: [
      {
        name: "Oczyszczanie wodorowe / kawitacyjne",
        desc: "Głębokie oczyszczenie skóry z zanieczyszczeń, martwych komórek i sebum. Efekt świeżości i rozświetlenia od pierwszej wizyty.",
        keyword: "oczyszczanie twarzy Katowice",
      },
      {
        name: "Mezoterapia mikroigłowa",
        desc: "Precyzyjne wprowadzanie aktywnych koktajli — nawilżenie, redukcja zmarszczek, poprawa napięcia. Rekomendowane w seriach.",
        keyword: "mezoterapia twarzy Katowice",
      },
      {
        name: "Masaż Kobido",
        desc: "Japoński masaż liftingujący — modelowanie owalu, redukcja napięcia mięśni, głęboka relaksacja i widoczne odmłodzenie.",
        keyword: "masaż Kobido Katowice",
      },
      {
        name: "Stymulatory tkankowe / PDRN",
        desc: "Biostymulacja skóry — pobudzenie procesów naprawczych, mocniejsza, gęstsza i bardziej sprężysta skóra.",
        keyword: "stymulatory tkankowe Katowice",
      },
      {
        name: "Rytuały pielęgnacyjne",
        desc: "Autorskie protokoły łączące pielęgnację manualną, kwasy oraz maski aktywne — dopasowane do typu i potrzeb skóry.",
        keyword: "zabiegi kosmetyczne Katowice",
      },
    ],
  },
};

export const PRICING = {
  nails: [
    { group: "Stylizacja paznokci" },
    { name: "Przedłużanie paznokci", price: "220 zł" },
    { name: "Utwardzenie naturalnej płytki", price: "200 zł" },
    { name: "Korekta paznokci do 4 tygodni", price: "150 zł" },
    { name: "Korekta paznokci po 4 tygodniach", price: "170 zł" },
    { name: "Hybryda", price: "140 zł" },

    { group: "Dopłaty" },
    { name: "Kolor", price: "+10 zł" },
    { name: "2–3 kolory", price: "+20 zł" },
    { name: "French", price: "+15–30 zł" },
    { name: "Baby boomer", price: "+10 zł" },
    { name: "Pyłki", price: "+10 zł" },
    { name: "Zdobienia (1–3 paznokcie)", price: "+20 zł" },
    { name: "Zdobienia (4–10 paznokci)", price: "+30–50 zł" },
  ],
  pedicure: [
    { group: "Pedicure frezarkowy" },
    { name: "Pedicure kosmetyczny", price: "120 zł" },
    { name: "Pedicure + lakier", price: "150 zł" },
    { name: "Pedicure + hybryda", price: "180 zł" },
    { name: "Pedicure + french", price: "200 zł" },
    { name: "Sama hybryda", price: "100 zł" },
    { name: "Ściągnięcie hybrydy + pielęgnacja", price: "120 zł" },
    { name: "Ściągnięcie żelu + pielęgnacja", price: "140 zł" },
  ],
  manicure: [
    { group: "Manicure" },
    { name: "Manicure kosmetyczne", price: "80 zł" },
    { name: "Manicure japoński", price: "100 zł" },
    { name: "Manicure + lakier", price: "100 zł" },
    { name: "Manicure + french", price: "110 zł" },
    { name: "Express mani", price: "50 zł" },
  ],
  depilation: [
    { group: "Depilacja" },
    { name: "Wąsik / baczki / broda / policzki", price: "30 zł" },
    { name: "Ręce", price: "100 zł" },
    { name: "Pachy", price: "70 zł" },
    { name: "Łydki", price: "80 zł" },
    { name: "Całe nogi", price: "150 zł" },
    { name: "Komplet", price: "350 zł" },
  ],
  eyes: [
    { group: "Stylizacja oka" },
    { name: "Regulacja brwi", price: "30 zł" },
    { name: "Henna brwi lub rzęs", price: "30 zł" },
    { name: "Henna + regulacja", price: "50 zł" },
    { name: "Komplet: rzęsy, brwi + regulacja", price: "60 zł" },
    { name: "Architektura brwi (rysunek)", price: "30 zł" },
    { name: "Laminacja brwi + botoks", price: "100 zł" },
    { name: "Laminacja brwi + farbka", price: "120 zł" },
    { name: "Laminacja rzęs + botoks", price: "100 zł" },
    { name: "Laminacja rzęs + farbka", price: "120 zł" },
    { name: "Komplet: brwi i rzęsy", price: "200 zł" },
  ],
  podology: [
    { group: "Podologia" },
    { name: "Konsultacja podologiczna", price: "100 zł" },
    { name: "Pedicure podologiczny", price: "180–200 zł" },
    { name: "Usunięcie odcisku / modzeli (1 szt.)", price: "50 zł" },
    { name: "Opracowanie paznokci zmienionych chorobowo", price: "120 zł" },
    { name: "Badanie mykologiczne", price: "150 zł" },
    { name: "Terapia mykologiczna (1 wizyta)", price: "150–200 zł" },
    { name: "Brodawka wirusowa — pierwsza wizyta", price: "180 zł" },
    { name: "Brodawka wirusowa — kolejne wizyty", price: "100 zł" },
    { name: "Klamra ortonyksyjna (1 szt.)", price: "200 zł" },
    { name: "Klamra ortonyksyjna (2 szt.)", price: "350 zł" },
    { name: "Kontrola klamr", price: "120–300 zł" },
    { name: "Rekonstrukcja paznokcia", price: "100 zł" },
    { name: "Nadbudowa plombą stomatologiczną", price: "30–80 zł" },
    { name: "Malowanie paznokci", price: "wg cennika stylizacji paznokci" },
  ],
  face: [
    { group: "Kosmetyka twarzy" },
    { name: "Konsultacja (30–40 min)", price: "80 zł" },

    { group: "Zabiegi oczyszczające (peeling kawitacyjny / oczyszczanie wodorowe / mikrodermabrazja)" },
    { name: "+ Maska kremowa", price: "160–200 zł" },
    { name: "+ Maska algowa", price: "180–220 zł" },
    { name: "+ Maska w płacie", price: "180 zł" },
    { name: "+ Maska kremowa + algowa", price: "200–250 zł" },

    { group: "Masaż twarzy (30 min)" },
    { name: "+ Maska kremowa", price: "160–180 zł" },
    { name: "+ Maska algowa", price: "180–200 zł" },
    { name: "+ Maska w płacie", price: "180 zł" },

    { group: "Peelingi chemiczne — dobierane indywidualnie" },
    { name: "Acne Out", price: "180–240 zł" },
    { name: "Anti-aging", price: "200–250 zł" },
    { name: "Soft Peel", price: "160–200 zł" },
    { name: "Glow Up", price: "180–220 zł" },

    { group: "Biorewitalizacja / peelingi średnio-głębokie" },
    { name: "TCA", price: "350–499 zł" },
    { name: "Retinolidy", price: "350–499 zł" },
    { name: "BioRePeel", price: "350–499 zł" },
    { name: "Glow X", price: "300–350 zł" },
    { name: "Mikronakłuwanie (dodatek do zabiegu)", price: "+100 zł" },

    { group: "Mezoterapia mikroigłowa" },
    { name: "Mezoterapia mikroigłowa + ampułka", price: "199–300 zł" },
    { name: "Mezoterapia + peel + ampułka", price: "250–350 zł" },
    { name: "Mezoterapia + Hydra Royal Peel", price: "350–450 zł" },
    { name: "Mezoterapia + Hydra Royal Peel + Egzosomy", price: "350–499 zł" },
  ],
};
